import { defineStore } from 'pinia'
import type { TemplateSettingType } from '@/modules/whiteboard/services/templates/IWhiteboardTemplate'

export const useWhiteboardStore = defineStore({
  id: 'whiteboardStore',
  state: () => ({
    currentBoardId: null as null | number,
    settings: undefined as undefined | Partial<Record<TemplateSettingType, Record<string, any>>>,
  }),
  actions: {
    setCurrentBoardId(value: number | null) {
      this.currentBoardId = value
    },
    setSettings(val?: Partial<Record<TemplateSettingType, Record<string, any>>>) {
      this.settings = val
    },
  },
})
